var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompanyTransfer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_132_1",
    "data-name": "Component 132 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.494,
    height: 13.112,
    viewBox: "0 0 18.494 13.112",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1378",
    "data-name": "Group 1378",
    transform: "translate(218.197 -20.971) rotate(90)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2221",
    "data-name": "Group 2221",
    transform: "translate(21.923 203.128)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3117",
    "data-name": "Path 3117",
    d: "M27.288,203.088l-4.459-5.174-4.459,5.174-1.146-1.33,5.6-6.506,5.6,6.506Z",
    transform: "translate(-17.225 -195.252)",
    fill: "#5d5b5c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_717",
    "data-name": "Rectangle 717",
    width: 1.778,
    height: 12.835,
    transform: "translate(4.715 2.233)",
    fill: "#5d5b5c"
  })), /*#__PURE__*/React.createElement("path", {
    id: "list_FILL0_wght400_GRAD0_opsz48",
    d: "M126.884,388.55v-1.784h13.111v1.784Z",
    transform: "translate(-105.912 -187.062)",
    fill: "#5d5b5c"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompanyTransfer);
export default __webpack_public_path__ + "static/media/company_transfer.78cd818b7173453cd1269c9281712cb7.svg";
export { ForwardRef as ReactComponent };